import { EvComboboxOption } from '@evinced-private/ui-common';

import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';

export const REMOVE_ISSUE_BUTTON_TITLE = 'Remove Issue Type Rule';
export const ACTION_LABEL = 'Action';
export const ACTION_PLACEHOLDER = 'Select Action';
export const ISSUE_TYPE_VALUE_LABEL = 'Issue Type';
export const ISSUE_TYPE_VALUE_PLACEHOLDER = 'Select Issue Type';
export const MAX_DISPLAYED_ITEMS = 200;

export const ISSUE_TYPES_ACTIONS: EvComboboxOption[] = [
	{ label: 'Include Issue Types', value: SCOPE_ACTIONS.INCLUDE },
	{ label: 'Exclude Issue Types', value: SCOPE_ACTIONS.EXCLUDE }
];
